module.exports = __webpack_public_path__ + "static/media/portfolio3.2e3556cd.jpg";